import { Injectable, DOCUMENT, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SplashscreenService {
  private document = inject<Document>(DOCUMENT);

  toggle() {
    this.document.body.classList.toggle('splashscreen');
  }

  show() {
    this.document.body.classList.add('splashscreen');
  }

  hide() {
    this.document.body.classList.remove('splashscreen');
  }

  isShown() {
    return this.document.body.classList.contains('splashscreen');
  }
}
